import { postRequest } from '@/core';
import { edi } from '@/requests';

export default async function(transmissionId) {
	let url = edi.reimportInboundTransmission(transmissionId);

	let result = await postRequest(url);
	return result;
}